import React from 'react';
import {
  Box,
  Chip,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import HistoryIcon from '@mui/icons-material/History';
import { getActionColor, getActionLabel, getEntityTypeLabel } from '../model/auditLogConstants';

function DetailRow({ label, value }) {
  return (
    <Box sx={{ display: 'flex', gap: 1.5, py: 0.75, borderBottom: '1px solid #f1f5f9' }}>
      <Typography variant="body2" sx={{ width: 140, flexShrink: 0, color: '#6b7280' }}>{label}</Typography>
      <Box sx={{ fontSize: '0.875rem', color: '#1f2937', wordBreak: 'break-word' }}>{value}</Box>
    </Box>
  );
}

export default function AuditLogDetailsDialog({ log, open, onClose }) {
  if (!log) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth PaperProps={{ sx: { borderRadius: 3 } }}>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1.5, pr: 6 }}>
        <Box sx={{
          width: 40, height: 40, borderRadius: 2.5, display: 'flex', alignItems: 'center', justifyContent: 'center',
          backgroundColor: '#0D6AEE1a', color: '#0D6AEE', flexShrink: 0,
        }}
        >
          <HistoryIcon fontSize="small" />
        </Box>
        <Box sx={{ minWidth: 0 }}>
          <Typography variant="h6" sx={{ fontWeight: 700, fontSize: '1.1rem' }}>Detalle del evento</Typography>
          <Typography variant="caption" sx={{ color: '#6b7280' }}>Registro #{log.id}</Typography>
        </Box>
        <IconButton onClick={onClose} sx={{ position: 'absolute', right: 12, top: 12 }}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <Stack spacing={0}>
          <DetailRow label="Fecha" value={new Date(log.createdAt).toLocaleString()} />
          <DetailRow
            label="Acción"
            value={<Chip size="small" color={getActionColor(log.action)} label={getActionLabel(log.action)} sx={{ fontWeight: 600 }} />}
          />
          <DetailRow label="Usuario" value={log.user ? `${log.user.nombre} (${log.user.email})` : `ID ${log.userId ?? '—'}`} />
          <DetailRow label="IP" value={log.ip ?? '—'} />
          <DetailRow label="Entidad" value={getEntityTypeLabel(log.entityType)} />
          <DetailRow label="ID de entidad" value={log.entityId ?? '—'} />
        </Stack>

        <Typography variant="body2" sx={{ mt: 3, mb: 1, fontWeight: 600, color: '#1f2937' }}>Datos adicionales</Typography>
        {log.details ? (
          <Box
            component="pre"
            sx={{
              m: 0, p: 2, borderRadius: 2, backgroundColor: '#f8fafc', border: '1px solid #e3e8ef',
              fontSize: '0.8rem', color: '#374151', overflow: 'auto', maxHeight: 260,
            }}
          >
            {JSON.stringify(log.details, null, 2)}
          </Box>
        ) : (
          <Typography variant="body2" sx={{ color: '#9ca3af' }}>Sin datos adicionales.</Typography>
        )}
      </DialogContent>
    </Dialog>
  );
}
